
import { ModalController, ViewController,NavParams } from 'ionic-angular';

import {Component, ElementRef, ViewChild} from '@angular/core';
import { NavController, AlertController, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Camera } from '@ionic-native/camera';
import { Storage } from '@ionic/storage';

import { UploadService } from '../../../services/upload-service';
import { Upload } from '../../../services/upload';

declare var cordova: any;
declare var google: any;
declare var window: any;

import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import { UiData } from "../../../providers/ui-data";
import { JobDataService } from '../../../providers/job-data';

import { SearchPipe } from '../../../pipes/search/search';

import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ProgressBarComponent } from '../../../components/progress-bar/progress-bar';
import * as firebase from "firebase";

import { File } from '@ionic-native/file';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';

import {MissionDetailPage} from "../../missions/mission-detail/mission-detail";

@Component({
    selector: 'page-locationviewer',
    templateUrl: 'location-viewer.html'
})
export class LocationViewer {

    @ViewChild('mapCanvas') mapElement: ElementRef;

    map:any;
    mission:any;
    searchFilters:any;
    markers: any = [];
    mapIsCentered:boolean = true;
    location_marker: any = false;
    infoWindow: any;
    directionsService: any;
    directionsDisplay: any;
    iconBase: string = 'assets/img/markers/';
    travelChooseMode: any = "";
    travelMode: any = google.maps.TravelMode.DRIVING;
    travelModes: any = {
        'car':google.maps.TravelMode.DRIVING,
        'bike':google.maps.TravelMode.BICYCLING,
        'walk':google.maps.TravelMode.WALKING,
        'bus':google.maps.TravelMode.TRANSIT,
    };
    travelDistance: any = "--";
    travelTime: any = "--";
    icons: any = {
        'industrie': {
            icon: this.iconBase + 'pin-agriculture.png',//'PICTOS_METIERS_industrie-resized.png'
        },
        'agriculture-et-peche': {
            icon: this.iconBase + 'pin-agriculture.png',//'PICTOS_METIERS_agriculture-resized.png'
        },
        'banque': {
            icon: this.iconBase + 'pin-banque.png',//'PICTOS_METIERS_banque-resized.png'
        },
        'arts-et-faconnage-d-ouvrages-d-art': {
            icon: this.iconBase + 'pin-art.png',//'PICTOS_METIERS_art-resized.png'
        },
        'commerce': {
            icon: this.iconBase + 'pin-commerce.png',//'PICTOS_METIERS_commerce-resized.png'
        },
        'communication': {
            icon: this.iconBase + 'pin-communication.png',//'PICTOS_METIERS_communication-resized.png'
        },
        'construction': {
            icon: this.iconBase + 'pin-construction.png',//'PICTOS_METIERS_construction-resized.png'
        },
        'hotellerie-restauration-tourisme-loisirs-et-animation': {
            icon: this.iconBase + 'pin-hotellerie.png',//'PICTOS_METIERS_hotellerie-resized.png'
        },
        'installation-et-maintenance': {
            icon: this.iconBase + 'pin-install-maintenance.png',//'PICTOS_METIERS_install-maintenance-resized.png'
        },
        'sante': {
            icon: this.iconBase + 'pin-sante.png',//'PICTOS_METIERS_sante-resized.png'
        },
        'services-a-la-personne-et-a-la-collectivite': {
            icon: this.iconBase + 'pin-service-personne.png',//'PICTOS_METIERS_service-personne-resized.png'
        },
        'spectacle': {
            icon: this.iconBase + 'pin-spectacle.png',//'PICTOS_METIERS_spectacle-resized.png'
        },
        'support-a-l-entreprise': {
            icon: this.iconBase + 'pin-support.png',//'PICTOS_METIERS_support-entreprise-resized.png'
        },
        'transport': {
            icon: this.iconBase + 'pin-transport.png',//'PICTOS_METIERS_transport-resized.png'
        },
        blue: {
            icon: this.iconBase + 'marker_azure-resized.png'
        },
        green: {
            icon: this.iconBase + 'marker_green-resized.png'
        },
        pink: {
            icon: this.iconBase + 'marker_pink-resized.png'
        },
        location: {
            icon: new google.maps.MarkerImage(this.iconBase + 'position.png',
                new google.maps.Size(22,22),
                new google.maps.Point(0,18),
                new google.maps.Point(11,11))
        }
    };

    constructor(
        public storage: Storage,
        public viewCtrl: ViewController,
        public params: NavParams,
        public alertCtrl: AlertController,
        public nav: NavController,
        public userData: UserData,
        public uiData: UiData,
        public navCtrl: NavController,

    ) {
        this.travelMode = this.travelModes.car;
        this.travelChooseMode = "car";
    }
    changeTravelModeTo(mode,fab)
    {
        this.userData.update('searchFilters','travelMode',mode);
        this.travelChooseMode = mode;
        this.travelMode = this.travelModes[mode];
        this.displayDirection();
        fab.close();
    }
    dismiss() {
        this.viewCtrl.dismiss();
    }
    createMap(){

        // Snazy map : https://snazzymaps.com/style/70/unsaturated-browns
        let mapEle = this.mapElement.nativeElement;
        this.map = new google.maps.Map(mapEle, {
            disableDefaultUI: true,
            zoom: 14,
            //styles:[{"elementType":"geometry","stylers":[{"hue":"#ff4400"},{"saturation":-68},{"lightness":-4},{"gamma":0.72}]},{"featureType":"road","elementType":"labels.icon"},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"hue":"#0077ff"},{"gamma":3.1}]},{"featureType":"water","stylers":[{"hue":"#00ccff"},{"gamma":0.44},{"saturation":-33}]},{"featureType":"poi.park","stylers":[{"hue":"#44ff00"},{"saturation":-23}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"hue":"#007fff"},{"gamma":0.77},{"saturation":65},{"lightness":99}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"gamma":0.11},{"weight":5.6},{"saturation":99},{"hue":"#0091ff"},{"lightness":-86}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"lightness":-48},{"hue":"#ff5e00"},{"gamma":1.2},{"saturation":-23}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"saturation":-64},{"hue":"#ff9100"},{"lightness":16},{"gamma":0.47},{"weight":2.7}]}]
            styles:[{"featureType":"all","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"all","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ff0000"}]},{"featureType":"administrative","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"geometry","stylers":[{"visibility":"off"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"color":"#ededed"}]},{"featureType":"landscape","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"weight":"2.00"},{"invert_lightness":true}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ff0000"}]},{"featureType":"landscape.natural","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ff0000"}]},{"featureType":"landscape.natural.terrain","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"poi","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"invert_lightness":true},{"weight":"2.00"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"hue":"#00dcff"}]},{"featureType":"poi.government","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"all","stylers":[{"color":"#ff0000"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#000000"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"invert_lightness":true},{"visibility":"on"},{"color":"#000000"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","elementType":"geometry.stroke","stylers":[{"visibility":"simplified"}]},{"featureType":"transit.station","elementType":"geometry.stroke","stylers":[{"weight":"2.00"},{"invert_lightness":true},{"visibility":"on"}]},{"featureType":"transit.station.rail","elementType":"geometry","stylers":[{"visibility":"on"},{"color":"#ff0000"}]},{"featureType":"transit.station.rail","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"invert_lightness":true},{"color":"#ff0000"},{"weight":"2.00"}]},{"featureType":"transit.station.rail","elementType":"geometry.stroke","stylers":[{"visibility":"on"},{"weight":"3.00"},{"color":"#111111"},{"invert_lightness":true}]}]
        });
        var that = this;
        google.maps.event.addListenerOnce(this.map, 'idle', () => {

            if(this.searchFilters.location.enabled)
            {
                if(this.location_marker)
                {
                    this.location_marker.setMap(null);
                    this.location_marker = new google.maps.Marker({
                        position: new google.maps.LatLng(this.searchFilters.location.lat, this.searchFilters.location.lng),
                        map: this.map,
                        icon: this.icons['location'].icon,
                    });
                }
                else
                {
                    let marker = new google.maps.Marker({
                        position: new google.maps.LatLng(this.searchFilters.location.lat, this.searchFilters.location.lng),
                        map: this.map,
                        icon: this.icons['location'].icon,
                    });
                    this.location_marker = marker;
                }
            }
            mapEle.classList.add('show-map');
            this.directionsService = new google.maps.DirectionsService;
            this.directionsDisplay = new google.maps.DirectionsRenderer({
                map: this.map
            });
            this.displayDirection();
            this.recenterMap();

        });

    }
    displayDirection(){
        var pointA = new google.maps.LatLng(this.searchFilters.location.lat, this.searchFilters.location.lng);
        var pointB = new google.maps.LatLng(this.mission.location_lat,this.mission.location_lng);
        var that = this;
        this.directionsService.route({
            origin: pointA,
            destination: pointB,
            travelMode: this.travelMode
        }, function(response, status) {
            if (status == google.maps.DirectionsStatus.OK) {
                that.directionsDisplay.setDirections(response);
                if(response.routes && response.routes.length>0)
                {
                    var route = response.routes[0];
                    if(route.legs && route.legs.length>0)
                    {
                        var leg = route.legs[0];
                        that.travelDistance = leg.distance.text;
                        that.travelTime = leg.duration.text;
                    }
                }
            } else {
                window.alert('Directions request failed due to ' + status);
            }
        });
    }
    updateMapCenter(){
        if(!this.map)
            this.createMap();

        if(this.searchFilters && this.searchFilters.location && this.searchFilters.location.lat) {
            this.map.setCenter(new google.maps.LatLng(this.searchFilters.location.lat, this.searchFilters.location.lng));
        }
        this.mapIsCentered=true;
    }
    recenterMap(){
        if(!this.map)
            this.createMap();

        if(this.searchFilters && this.searchFilters.location && this.searchFilters.location.lat) {
            this.map.setZoom(14);
            this.updateMapCenter();
        }

    }
    ionViewDidLoad() {
        this.mission=this.params.get('mission');
        this.searchFilters=this.params.get('searchFilters');

        if(this.searchFilters.travelMode)
        {
            this.travelChooseMode = this.searchFilters.travelMode;
            this.travelMode = this.travelModes[this.searchFilters.travelMode];
        }
        if(!this.map)
            this.createMap();

    }
}


// WEBPACK FOOTER //
// ./src/pages/utils/location-viewer/location-viewer.ts